import { Inject, Injectable, Injector } from '@angular/core';

import { IntraOne_FlowService } from './IntraOne.flow.index';


import { $frontendTypes } from './app.frontend.types'

@Injectable({ providedIn: 'root' })
export class app_FlowService {

  constructor(
    private injector: Injector
  ) {
    this.IntraOne = this.injector.get(IntraOne_FlowService);
  }

    public IntraOne: IntraOne_FlowService;
  public app: app_FlowService = this;

  // injecting lazily in order to avoid circular dependencies
}
